import React from 'react';
import { connect } from 'react-redux';
import './MerkleDemo.css';
import * as actions from '../actions.js';
import Tree from 'react-d3-tree';

import {
    Grid,
    PageHeader,
    Row,
    Col,
    ControlLabel,
    FormControl,
    Button,
} from 'react-bootstrap';


const treeBoxHeight = 600,
    svgSquare = {
        shape: 'rect',
        shapeProps: {
            width:20,
            height:20,
            x:-10,
            y:-10,
        },
    };



function InputInfoBox({info}) {
    console.log('information', info);
    //return <div>information!</div>;
    return <div></div>;
}


function MerkleDemo({
    tree,
    treeKey,
    textToAdd,
    approxSize,
    treeLevels,
    activeInfoBox,
    stageFiles,
    stageText,
    addText,
    addFiles,
    nodeClick,
}) {
    return (
        <Grid>
            <PageHeader>
                Merkle Tree Demonstration
            </PageHeader>
            <Row>
                <Col xs={12}>
                    <div className="merkletree-container-outer">
                        <div className="merkletree-container-inner">
                            <Tree
                                key={"merkletree" + treeKey}
                                data={tree}
                                zoomable={false}
                                orientation="vertical"
                                pathFunc="straight"
                                translate={{x:1000, y:30}}
                                onClick={nodeClick}
                                collapsible={false}
                                nodeSvgShape={svgSquare}
                                separation={{siblings:approxSize, nonSiblings:approxSize}}
                                depthFactor={(treeBoxHeight - 100) / treeLevels}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className="fileinforow">
                <Col xs={12}>
                    {
                        activeInfoBox
                        ? <InputInfoBox info={activeInfoBox} />
                        : null
                    }
                </Col>
            </Row>
            <Row>
                <Col xs={6}>
                    <ControlLabel>Add files</ControlLabel>
                    <FormControl type="file" className="merklefileinputbutton" multiple onChange={stageFiles} />
                    <Button bsSize="small" bsStyle="catallaxy" onClick={addFiles}>Add</Button>
                </Col>
                <Col xs={6}>
                    <ControlLabel>Add text inputs</ControlLabel>
                    <textarea
                        id="textinput"
                        name="textinput"
                        rows="2"
                        placeholder="type something here"
                        value={textToAdd}
                        onChange={stageText}
                    ></textarea>
                    <Button bsSize="small" bsStyle="catallaxy" onClick={addText}>Add</Button>
                </Col>
            </Row>
        </Grid>
    );
}


function stateToProps({ merkle }) {
    const inputSize = merkle.leafInputs ? merkle.leafInputs.length : 1,
        treeLevels = Math.ceil(Math.log(inputSize) / Math.log(2)) + 1,
        outputSize = Math.pow(2, (treeLevels - 1)),
        approxSize = Math.max(Math.min(( 4 / outputSize ), 5), 0.3);
    return {
        tree: merkle.tree,
        treeKey: merkle.treeKey,
        textToAdd: merkle.stagedText,
        approxSize,
        treeLevels,
        activeInfoBox: merkle.activeInfoBox,
    };
}
function dispatchToProps(dispatch) {
    return {
        stageFiles(evt) {
            dispatch(actions.stageMerkleFiles(evt.target.files));
        },
        stageText(evt) {
            dispatch(actions.stageMerkleText(evt.target.value));
        },
        addText() {
            dispatch(actions.addMerkleText());
        },
        addFiles() {
            dispatch(actions.addMerkleFiles());
        },
        nodeClick(node) {
            if( !node ) {
                console.log('not really a node?', node);
            }
            else if( !node.parent ) {
                console.log('root node', node);
            }
            else if( node.children ) {
                console.log('intermediate node', node);
            }
            else {
                console.log('leaf node', node);
                dispatch(actions.viewMerkleInput(node));
            }
        },
    };
}

export default connect(stateToProps, dispatchToProps)(MerkleDemo);





// WEBPACK FOOTER //
// ./src/components/MerkleDemo.js